enum Constants {
  TOKEN_STORAGE_KEY = '.OnixV2PortalIntegration',
  AUTHORIZATION_CODE = 'sensediaAuthorizationCode',
  TOKEN_STORAGE_PEDIDOS_KEY = '.OnixV2PortalIntegrationPedidos',
  USER_STORAGE_KEY = 'userInfo',
  CREDENTIALS_STORAGE_KEY = 'userCredentials',
  USER_LASTROUTER_KEY = 'lastRouter',
  ONIX_STORAGE_KEY = '.AspNet.ApplicationCookieOnixPortal',
  ONIX_SESSION_ID_KEY = 'ASP.NET_SessionId',
  SALESFORCE_REF = 'salesforce-embedded-messaging',
  USER_ONBOARDING = 'userOnboarding',
  CONTACT_TELVR = '(11) 4004-4938',
  NOME_DA_EMPRESA = 'VR Mobilidade e Tecnologia S.A.',
  CONTACT_OTERS = '0800 596 3838',
  ERROR_DATA = 'Erro ao processar os dados',
  PARENT_LOCATION = 'PARENT.EVENT.LOCATION',
  TYPE_PREFIX = 'THIRD-PARTY-APP',
  PARENT_PREFIX = 'PARENT.EVENT',
  iS_ONBOARDING_FINISHED = 'isOnboardingFinished',
  iS_ONBOARDING_FINISHED_CREATE_ORDER = 'isOnboardingFinishedCreateOrder',
  iS_ONBOARDING_FINISHED_ORDER_PENDING = 'isOnboardingFinishedOrderPending',
  iS_ONBOARDING_FINISHED_ORDER_REVIEW = 'isOnboardingFinishedOrderReview',
  APP_SISTEM = 'ABSCardVR',
  VRACCESS_SESSION_KEY = 'isVrAccess',
  SPE_MIGRATION_JOURNEY_DATA = 'userMigrationStatus',
  SPE_DISABLED_MODAL_MIGRATION_JOURNEY = 'speDisabledModal',
  FORCE_SANITIZATION = 'forceSanitization '
}

export default Constants
